<script>
/*jshint esversion: 6 */
import {ref, inject} from 'vue';
import { validator } from '@js/form_validators';

export default {
    name: 'LoginBox',     
    props: {
        'fetchBox': Object,
        'loginBox':  Object,
        'model': Object, 
        'schema':Object,
        'typonautenMail': String,
    },  
    setup(props, ctx) {
        //injections
        const openLayer = inject('openLayer');
        const closeLayer = inject('closeLayer');
        const changeWaitBox = inject('changeWaitBox');
        //variables
        const vfg = ref(null);
        const errorNewUserText=  ref('');
        const loginError= ref('');
        const pType1= ref('password');
        const passwordLogin= ref('');
        const showModel = ref(false);
        const showSelection= ref(1); 
        const stayLogin=  ref(0);
        const userLogin= ref(''); 
        const validators = ref(validator());


        function checkModel() {
            if (vfg.value.validateAll() === true) {
                submitNewUser();
            }
        }
        function createNewUser() {
            var url = 'login.php';
            var submitData = new FormData();
            submitData.append('email', props.model.email);
            submitData.append('password', props.model.password);
            submitData.append('company', props.model.company);
            submitData.append('name', props.model.name);
            submitData.append('status', 'createNewUser');

            props.fetchBox.fetchData(url, submitData, 'create new user').then(response =>  {
                document.getElementById('newUserButton').disabled = false;
                if (response.processResponse === true) {
                    closeLayer();

                    if (response.processResponse === true) {
                        switch(parseInt(response.message)) {
                            case 1:
                                showSelection.value = 3;
                            break;
                            case 2:
                                showSelection.value = 4;
                            break;
                        }
                    }
                }
            });
        }
        function showPassword(id, type) {
            if (id === 'pType1') pType1.value = type;
        }
        function showSelectionFunc(id) {
            if (id === 'login') showSelection.value = 1;
            if (id === 'newUser') showSelection.value = 2;
        }
        function submitLogin() {
            if (passwordLogin.value !== '' && userLogin.value !== '') {
                var bodyData = new FormData();
                bodyData.append('email', userLogin.value);
                bodyData.append('password', passwordLogin.value);
                bodyData.append('stay', stayLogin.value);
                bodyData.append('status', 'checkLogin');
                var url = 'login.php';
                openLayer('wait', true);
                changeWaitBox(3);
                props.fetchBox.fetchData(url, bodyData, 'login').then(response =>  {
                    closeLayer();
                    try {
                        switch (parseInt(response.message.regCode)) {
                            case 5:
                                var duration = 300-parseInt(response.message.duration);
                                var toHHMMSS = (secs) => {
                                    var sec_num = parseInt(secs, 10);
                                    var hours   = Math.floor(sec_num / 3600);
                                    var minutes = Math.floor(sec_num / 60) % 60;
                                    var seconds = sec_num % 60;
                            
                                    if (minutes < 10) minutes = `0${minutes}`;
                                    if (seconds < 10) seconds = `0${seconds}`;
                            
                                    return [hours,minutes,seconds];
                                };

                                var balanceTime = toHHMMSS(duration);
                                loginError.value = `Dieses Konto ist vorübergehend aufgrund zu vieler Fehlanmeldungen gesperrt. Bitte warten Sie noch ${balanceTime[1]} Minuten und ${balanceTime[2]} Sekunden und versuchen Sie es dann erneut.`;
                                break;
                            case 0:
                                loginError.value = 'Dieser User existiert nicht in unserem System.';
                                break;
                            case 4: 
                                loginError.value = `Das Passwort ist falsch. Bitte probieren Sie es noch einmal. Bitte beachten Sie: Sie hatten jetzt ${response.message.tryOuts} Fehlversuche. Beim 4. Fehlversuch wird die Anmeldemöglichkeit für Sie aus Sicherheitsgründen für 5 Minuten gesperrt.`;
                                break;
                            case 3:
                                loginError.value = 'Ihr Account wurde noch nicht freigeschaltet. Bitte warten Sie auf eine Bestätigungs-E-Mail durch die Typonauten.';
                                break;
                            case 2:
                                sessionStorage.setItem('wnPortal_username', response.userData.username);
                                sessionStorage.setItem('wnPortal_status', response.userData.status);
                                sessionStorage.setItem('wnPortal_userId', response.userData.userId);
                                sessionStorage.setItem('wnPortal_company', response.userData.company);
                                sessionStorage.setItem('wnPortal_email', response.userData.email);
                                sessionStorage.setItem('wnPortal_login', response.userData.login);
                                sessionStorage.setItem('wnPortal_maintenanceAdmin', response.userData.maintenanceAdmin);
                                sessionStorage.setItem('wnPortal_csv2pdf', response.userData.csv2pdf);
                                if (response.userData.signature !== null) {
                                    sessionStorage.setItem('wnPortal_signature', response.userData.signature);
                                }
                                sessionStorage.setItem('wnPortal_serviceProvider', response.userData.serviceProvider);

                                if (parseInt(response.userData.wnPortal_maintenance) === 1) {
                                    sessionStorage.setItem('wnPortal_maintenance', true);
                                    if (parseInt(response.userData.maintenanceAdmin) === 1) {
                                        window.location.href = 'search.php'; 
                                    } else {
                                        window.location.href = 'index.php';
                                    }
                                } else {
                                    window.location.href = 'search.php'; 
                                }

                                break;
                            default:
                                throw new Error(response.message);
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });

            } else {
                loginError.value = 'Bitte geben Sie eine E-Mail-Adresse und/oder ein Passwort ein.';
            }
        }  
        function submitNewUser() {
            var submitData = new FormData();
            var url = 'login.php';
            submitData.append('email', props.model.email);
            submitData.append('status', 'checkNewUser');
            document.getElementById('newUserButton').disabled = true;
            openLayer('wait', true);
            changeWaitBox(7);

            props.fetchBox.fetchData(url, submitData, 'New User').then(response =>  {
                document.getElementById('newUserButton').disabled = false;
                if (response.processResponse === true) {
                    if (response.message.length > 0) {
                        closeLayer()
                        errorNewUserText.value = 'Diese E-Mail-Adresse existiert bereits in der Datenbank. Bitte melden Sie sich mit Ihren Benutzerdaten an oder erstellen Sie ein neues Passwort.';
                    } else {
                        createNewUser();
                    }
                }
            });
        }
        
        return {
            checkModel,
            errorNewUserText, 
            loginError, 
            openLayer,
            pType1, 
            passwordLogin, 
            showModel,
            showPassword, 
            showSelection, 
            showSelectionFunc, 
            stayLogin, 
            submitLogin, 
            submitNewUser, 
            userLogin,
            validators,
            vfg,
        }
    }
}
</script>
<template lang="pug">
#login
    .loginContainer
        #showLoginArea(v-if="showSelection === 1 || showSelection === 2")
            h1 Login
            br
            br
            .myRadioLogin
                input#loginInput(type="radio" name="showSelection" checked value="login" @change="showSelectionFunc('login')")
                label(for="loginInput") Login mit bestehendem Konto
            #loginBox.loginBox(v-if="showSelection === 1")  
                br
                .form-group.row.gy-2.gx-3-align-items-left
                    .col-sm-3 
                        label.setLabel(for="email1") E-Mail
                    .col-sm-7 
                        input.form-control#email1(type="text" v-model="userLogin")
                br
                .form-group.row.gy-2.gx-3-align-items-left
                    .col-sm-3 
                        label.setLabel(for="passwort1") Passwort
                    .col-sm-7 
                        input.form-control#passwort1(:type="pType1" v-model="passwordLogin")
                    .col-auto.eyeIcon
                        FontAwesomeIcon(v-if="pType1 === 'password'" icon="fa-solid fa-eye" @click="showPassword('pType1', 'text')")
                        FontAwesomeIcon(v-if="pType1 === 'text'" icon="fa-solid fa-eye-slash" @click="showPassword('pType1', 'password')")    
                br
                .form-group.row.gy-2.gx-3-align-items-left
                    .col-sm-11.forgotPassword(@click="openLayer('passwordForgot', false)") Passwort vergessen 
                .form-group.row.gy-2.gx-3-align-items-left
                    .col-sm-11.error#loginError {{ loginError }}
                br
                .form-group.row.gy-2.gx-3-align-items-left
                    #checkStay 
                        div.col-sm-11
                            input#stay(type="checkbox" name="stay" true-value="1" false-value="0" v-model="stayLogin")
                            label(for="stay")
                                span.checkStayBox(v-if="parseInt(stayLogin) === 1")
                                    FontAwesomeIcon(icon="fa-solid fa-check")
                                span.checkStayBox.checkEmpty(v-if="parseInt(stayLogin) === 0")
                                    FontAwesomeIcon(icon="fa-solid fa-check")
                                | für 30 Tage eingeloggt bleiben 
                            br
                            span.small(style="font-weight:normal")
                                | &lpar;Bei Auswahl dieser Funktion stimmen Sie der Verwendung von Cookies auf dieser
                                | Webseite zu.&nbsp;
                                | Weitere Informationen zu Cookies erhalten Sie in unserer&nbsp;
                                span.linkDsgvo
                                    u(@click="openLayer('dsgvo', false)" style="cursor:pointer;") Datenschutzerklärung
                                |.&rpar;
                br
                .form-group.row.gy-2.gx-3-align-items-left
                    .submitDiv  
                        button.btn.btn-default2(@click="submitLogin('user', 'passwordStart')") anmelden
            br
            .myRadioLogin
                input#newUserInput(type="radio" name="showSelection" value="newUser" @change="showSelectionFunc('newUser')")
                label(for="newUserInput") neues Konto anlegen
            div#newUserBox.loginBox(v-if="showSelection === 2")
                br
                span.infoNewUser 
                    | Dieses Medienportal ist nur Mitarbeitern von wesernetz Bremen GmbH oder wesernetz Bremerhaven GmbH vorbehalten.
                    | Da wir Ihre Anmeldung sorgfältig prüfen, kann sich die Freischaltung Ihres Accounts ein
                    | wenig verzögern. Bitte haben Sie dafür Verständnis.
                br
                br
                vueForm(
                    ref="vfg"
                    :model="model"
                    :schema="schema"
                    @submitNewData="submitNewUser"
                    :showModel="showModel"
                    :validators="validators"
                ) 
                span.error#errorNewUser( style="line-height: 25px;") {{ errorNewUserText }}
                br
                .submitDiv
                    button#newUserButton.btn.btn-default2(@click="checkModel()") Registrieren
        #successNewUser(v-if="showSelection === 3")
            h3 Anmeldung erfolgreich 
            br
            | Hallo {{ model.name }},
            br
            br
            | Ihre Anmeldung wurde erfolgreich durchgeführt.
            br
            | Nach Freischalten Ihres Zugangs durch uns, werden Sie per E-Mail darüber informiert und 
            | können sich einloggen.
            br
            br
            | Viel Freude mit dem wesernetz Medienportal,
            br
            | die Typonauten
            br
            br
            div.submitDiv
                button.btn.btn-default2(@click="showSelection = 1") zurück zur Startseite
        #successNewUser(v-if="showSelection === 4")
            h3 Die Anmeldung war erfolgreich aber die E-Mail wurde nicht versandt
            br
            | Hallo {{ model.name }},
            br
            br
            | Ihre Anmeldung wurde erfolgreich durchgeführt.
            br
            | Leider konnte die Bestätigungs-E-Mail nicht an Sie oder an die Typonauten versendet werden. 
            br
            br
            | Bitte melden Sie sich per E-Mail an 
            a(:href="`mailto:${typonautenMail}`") {{ typonautenMail }}
            | &nbsp;, damit wir Sie händisch freischalten können.
            br
            br
            | Vielen Dank für Ihr Verständnis,
            br
            | die Typonauten
            br
            br
            div.submitDiv
                button.btn.btn-default2(@click="showSelection = 1") zurück zur Startseite
</template> 

<style lang="scss">
@import '../../css/variables';

.eyeIcon {
    font-size: 1.5em;
    color: $red;
    cursor: pointer;
    padding-top: 6px;
}
.setLabel {
    padding-top: 6px;
    font-family: $font-bold;
}

.loginContainer,
#errorLogin {
    width: 50%;
    @media screen and (max-width: 1200px) {
        width: 80%;
    }
    @media screen and (min-width: 2000px) {
        width: 40%;
    }
    margin: 0 auto;
    margin-bottom: 50px;
    padding: 20px;
    font-size: 16px;
    line-height: 25px;
    background: $white;
    margin-top: 150px;
    .error { 
        color: $red; 
        line-height: 25px;
        font-size: 0.8em;
    }
    .checkStayBox {
        width: 20px;
        height: 20px;
        border: 1px solid $red;
        display: inline-block;
        border-radius: 2px;
        position: relative;
        top: 2px;
        margin-right: 10px;
        svg {
            position: relative;
            top: -2px;
            left: 2px;
            color: $red;
        }
    }
    .checkEmpty {
        color: $white;
        svg {
            color: $white;
        }
    }
    #checkStay {
        label {
            display:inline;
            cursor: pointer;
        }
        input {
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
        }
    }
    .myRadioLogin {
        background: $white;
        input {
            display:none;
            &:checked + label:before {
                background: $red; 
                box-shadow: inset 0 0 0 2px $white;
            }
        }
        label {
            font-weight: bold;
            cursor: pointer;
            &:before {
                content:'';
                display:inline-block;
                width: 15px;
                height:15px;
                position: relative;
                top:2px;
                border: 1px solid $red;
                background: $white;
                margin-right: 1em;
                border-radius: 40px;
            }
            &:hover:before {
                border: 1px solid $red;
                background: $red;
                box-shadow: inset 0 0 0 2px $white;
            }
        }
    }
    h1 { font-family: $font-family; }
    .loginSpan { font-family: $font-bold; }
    .loginBox {
        margin-left: 31px;
        .forgotPassword {
            font-size: 14px;
            cursor: pointer;
            text-decoration: underline;
            text-align: right;
        }
        .infoNewUser {
            font-size: 14px;
        }
    }
    #newUserBox {
        width: 80%;
    }
}
#newUserBox { 
    .fieldInput {
        padding: 1em 0em;
    }
}
</style>